var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"margin-of-error",style:({width: _vm.marginOfErrorWidth, left: _vm.marginOfErrorShiftLeft, right: _vm.marginOfErrorShiftRight})})}
var staticRenderFns = []

export { render, staticRenderFns }